import React from 'react';

function HubSearchBar({ value, onChange, placeholder, type, onClickSearch }) {
  return (
    <>
      <div className="search_container">
        <input
          type={type || 'text'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="search_input"
        />
        <button className="search_button" onClick={onClickSearch}>
          <img 
            draggable="false" 
            src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-search.svg?v=1713944974" 
            alt="icon-search" 
          />
        </button>
      </div>
      <style jsx>{`
        .search_button {
          background: none;
          border: none;
          user-select: none;
          position: absolute;
          right: 0;
          height: 48px;
          width: 48px;
        }
        .search_button:focus {
          border: 1px solid #242424;
        }
        .search_container {
          position: relative;
          width: 640px;
          height: 48px;
        }
        .search_input {
          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: left;
          background: #141414;
          border: 1px solid #242424;
          border-radius: 4px;
          padding: 14px 16px;
          width: 640px;
          height: 48px;
          color: #e4e4e4;
        }
        .search_input:focus {
          border: 1px solid #242424;
        }
        @media (width<=768px) {
          .search_input,
          .search_container {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
}

export default HubSearchBar;
